import { useState, useEffect } from 'react';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import OpenInNew from '@mui/icons-material/OpenInNew';

import { TermsCheckboxUiOptions } from './schema';
import Box from '@mui/material/Box';

export { TermsCheckboxSchema } from './schema';

export const TermsCheckbox = (
  props: FieldExtensionComponentProps<boolean, TermsCheckboxUiOptions>,
) => {
  const { onChange, schema, required, formData, rawErrors, uiSchema } = props;

  const {
    labelText,
    prefixText = '',
    linkText,
    linkUrl,
    suffixText = '',
  } = uiSchema['ui:options'] ?? {};

  const [checked, setChecked] = useState(Boolean(formData ?? false));

  useEffect(() => {
    setChecked(Boolean(formData ?? false));
  }, [formData]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    onChange(isChecked);
  };

  const hasError = rawErrors && rawErrors.length > 0;

  return (
    <Box>
      <FormControl required={required} error={hasError} component="fieldset">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              required={required}
            />
          }
          label={
            <Typography component="span">
              {labelText ? (
                labelText
              ) : (
                <>
                  {prefixText ? <>{prefixText}</> : null}
                  {linkText && linkUrl ? (
                    <>
                      {prefixText ? ' ' : null}
                      <Link
                        href={linkUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        sx={{ display: 'inline-flex', alignItems: 'center' }}
                      >
                        {linkText}
                        <OpenInNew fontSize="small" sx={{ marginLeft: 0.5 }} />
                      </Link>
                    </>
                  ) : null}
                  {suffixText ? <>{suffixText}</> : null}
                </>
              )}
            </Typography>
          }
        />
        <FormHelperText>
          {hasError ? rawErrors.join(', ') : schema.description}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};
